import { Layer } from 'react-map-gl'

export default function BorderLayer({ source, sourceLayer = source, id = 'border-municipises' }) {
	return (
		<Layer
			id={id}
			source={source}
			source-layer={sourceLayer}
			type='line'
			beforeId='land-structure-line'
			paint={{
				'line-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 1, 0.5],
				'line-color': ['case', ['boolean', ['feature-state', 'hover'], false], 'white', 'white'],
				'line-width': ['case', ['boolean', ['feature-state', 'hover'], false], 2, 0.5],
			}}
		/>
	)
}
